module.exports = "<prg-select-interaction></prg-select-interaction>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-sensors/select-sensor-event/select-sensor-event.component.html
// module id = 1599
// module chunks = 2